/**
 * The one customer AI gate: the consolidated setting, or the two columns it replaces while both are still on
 * the wire. How often the fallback still fires is measured server-side in orioniq-be, and reaching zero is
 * what lets gaia-full stop sending the legacy pair (ORIONIQ-1645 phase 4).
 */
export const resolveAiEnabled = (settings) => settings?.aiEnabled ?? Boolean(settings?.aiPromptsEnabled || settings?.aiInvocationsEnabled);
//# sourceMappingURL=ai-utils.js.map